<script>
import getInitials from '@/helpers/get-initials'
import api from '@/helpers/api'
export default {
  name: 'customer.info',
  props: {
    customer_id: { type: String, required: true }
  },
  data: () => ({
    isLoading: false,
    customer: {
      billing_address: {}
    }
  }),
  mounted () {
    this.onInit()
  },
  watch: {
    customer_id: { handler: 'onInit', immediate: true }
  },
  methods: {
    async onInit () {
      this.isLoading = true
      let item = await api.customers.fetch({
        id: this.customer_id
      })
      this.customer = {
        ...item,
        initials: getInitials(item.legal_name),
        billing_email: item.billing_email.join(';')
      }
      this.isLoading = false
    },
    async onSave () {
      let valid = true

      if (valid) {
        const data = {
          ...this.customer,
          billing_email: this.customer.billing_email.split(';')
        }
        try {
          this.isLoading = true
          let item = await api.customers.update({
            ...data,
            id: this.customer_id
          })

          this.$bvToast.toast(`Billing Settings where saved!`, {
            title: 'Changes Saved',
            solid: true,
            toaster: 'b-toaster-top-center',
            variant: 'success',
            autoHideDelay: 1000,
            appendToast: true
          })
          this.isLoading = false
        } catch (error) {
          this.isLoading = false

          this.$bvToast.toast(`${error}!`, {
            title: 'Error',
            solid: true,
            toaster: 'b-toaster-top-center',
            variant: 'danger',
            autoHideDelay: 1000,
            appendToast: true
          })
        }
      }
    }
  }
}
</script>
<template>
  <g-overlay :show="isLoading">
    <b-card>
      <h4 class="card-title">Billing Settings</h4>
      <b-form-group
        label="EU Vat Exempt"
        label-for="eu_vat_exempt"
        label-cols-sm="4"
        label-cols-lg="3"
        class="align-items-center"
      >
        <template v-slot:label>
          <div class="d-flex align-items-center">
            EU Vat Exempt
            <i
              class="bx bx-info-circle mx-4 font-size-20"
              id="info_eu_vat_exempt"
            ></i>
          </div>
        </template>
        <b-form-checkbox
          switch
          size="lg"
          id="eu_vat_exempt"
          v-model="customer.eu_vat_exempt"
          name="eu_vat_exempt"
        ></b-form-checkbox>
        <b-tooltip
          target="info_eu_vat_exempt"
          triggers="hover"
          placement="right"
          >Enable this option if the customer's Headquarters is located in
          EU-Country.</b-tooltip
        >
      </b-form-group>
      <b-form-group
        label-for="send_digital_invoice"
        label-cols-sm="4"
        label-cols-lg="3"
        class="d-flex align-items-center"
      >
        <template v-slot:label>
          <div class="d-flex align-items-center pointer">
            Send Digital Invoice
            <i
              class="bx bx-info-circle mx-4 font-size-20"
              id="info_send_digital_invoice"
            ></i>
          </div>
        </template>
        <b-form-checkbox
          switch
          size="lg"
          id="send_digital_invoice"
          v-model="customer.send_digital_invoice"
          name="send_digital_invoice"
          inline
        ></b-form-checkbox>
        <b-tooltip
          target="info_send_digital_invoice"
          triggers="hover"
          placement="right"
          >Enable this option if the customer's wants to receive a digital
          invoice.</b-tooltip
        >
      </b-form-group>
      <b-form-group
        label="Billing Email"
        label-for="invoice_emails"
        label-cols-sm="4"
        label-cols-lg="3"
        class="d-flex align-items-center"
        v-if="customer.send_digital_invoice"
      >
        <b-form-input
          id="invoice_emails"
          v-model="customer.billing_email"
          type="text"
          required
          autocomplete="invoice_emails"
          placeholder="ex. invoice@company.com;accounting@company.com"
          :style="{ maxWidth: '800px' }"
        ></b-form-input>
      </b-form-group>
      <b-form-group
        v-if="false"
        label="Payment Term"
        label-for="payment_term"
        label-cols-sm="4"
        label-cols-lg="3"
        class="d-flex align-items-center"
      >
        <app-payment-term-select v-model="customer.payment_term_id" />
      </b-form-group>
      <b-form-group
        label-for="send_digital_invoice"
        label-cols-sm="4"
        label-cols-lg="3"
        class="d-flex align-items-center"
      >
        <template v-slot:label>
          <div class="d-flex align-items-center pointer">
            Structured Reference
            <i
              class="bx bx-info-circle mx-4 font-size-20"
              id="info_use_structured_reference"
            ></i>
          </div>
        </template>
        <b-form-checkbox
          switch
          size="lg"
          id="use_structured_reference"
          v-model="customer.use_structured_reference"
          name="use_structured_reference"
          inline
        ></b-form-checkbox>
        <b-tooltip
          target="info_use_structured_reference"
          triggers="hover"
          placement="right"
          >Use Structured Reference on Invoice.</b-tooltip
        >
      </b-form-group>

      <div class="d-flex justify-content-end">
        <b-btn class="btn-label" variant="primary" v-on:click="onSave">
          <i class="bx bx-save label-icon"></i>Save Changes
        </b-btn>
      </div>
    </b-card>
  </g-overlay>
</template>
